"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var types_generated_exports = {};
__export(types_generated_exports, {
  isAttachment: () => isAttachment,
  isAttachmentCategory: () => isAttachmentCategory,
  isAttachmentCreate: () => isAttachmentCreate,
  isAttachmentFolder: () => isAttachmentFolder,
  isAttachmentId: () => isAttachmentId,
  isAttachmentNaming: () => isAttachmentNaming,
  isAttachmentUpdate: () => isAttachmentUpdate,
  isAttachmentVariantId: () => isAttachmentVariantId,
  isContentType: () => isContentType,
  isResolveMethod: () => isResolveMethod,
  isResolveResponse: () => isResolveResponse
});
module.exports = __toCommonJS(types_generated_exports);
var import_types_generated = require("../core/types.generated.js");
var import_types_generated2 = require("../user/types.generated.js");
var import_util = require("@cartographerio/util");
const isAttachmentId = (v) => {
  return (0, import_util.bridgesIsTaggedHack)((a0) => a0 === "AttachmentId")(v);
};
const isContentType = (v) => {
  return (0, import_util.bridgesIsTaggedHack)((a0) => a0 === "ContentType")(v);
};
const isAttachmentFolder = (v) => {
  return typeof v === "object" && v != null && "folder" in v && typeof v.folder === "string";
};
const isAttachmentVariantId = (v) => {
  return v === "original" || v === "preview" || v === "320x240" || v === "640x480" || v === "1280x960";
};
const isAttachmentCategory = (v) => {
  return v === "image" || v === "text" || v === "document" || v === "spreadsheet" || v === "presentation" || v === "archive" || v === "unknown";
};
const isAttachmentNaming = (v) => {
  return v === "Original" || v === "Title" || v === "Id";
};
const isAttachment = (v) => {
  return typeof v === "object" && v != null && "surveyId" in v && (0, import_types_generated.isSurveyId)(v.surveyId) && "folder" in v && isAttachmentFolder(v.folder) && "filename" in v && typeof v.filename === "string" && "contentType" in v && isContentType(v.contentType) && (!("title" in v) || typeof v.title === "string" || v.title === null) && (!("description" in v) || typeof v.description === "string" || v.description === null) && "author" in v && (0, import_types_generated2.isUserRef)(v.author) && "license" in v && (0, import_types_generated.isDataLicense)(v.license) && "created" in v && (0, import_types_generated.isTimestamp)(v.created) && "updated" in v && (0, import_types_generated.isTimestamp)(v.updated) && "id" in v && isAttachmentId(v.id);
};
const isAttachmentCreate = (v) => {
  return typeof v === "object" && v != null && "surveyId" in v && (0, import_types_generated.isSurveyId)(v.surveyId) && "folder" in v && isAttachmentFolder(v.folder) && (!("title" in v) || typeof v.title === "string" || v.title === null) && (!("description" in v) || typeof v.description === "string" || v.description === null) && (!("author" in v) || (0, import_types_generated2.isUserRef)(v.author) || v.author === null) && (!("license" in v) || (0, import_types_generated.isDataLicense)(v.license) || v.license === null);
};
const isAttachmentUpdate = (v) => {
  return typeof v === "object" && v != null && (!("title" in v) || typeof v.title === "string" || v.title === null) && (!("description" in v) || typeof v.description === "string" || v.description === null) && (!("author" in v) || (0, import_types_generated2.isUserRef)(v.author) || v.author === null) && (!("license" in v) || (0, import_types_generated.isDataLicense)(v.license) || v.license === null);
};
const isResolveMethod = (v) => {
  return v === "get" || v === "head";
};
const isResolveResponse = (v) => {
  return typeof v === "object" && v != null && "method" in v && typeof v.method === "string" && "url" in v && typeof v.url === "string";
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  isAttachment,
  isAttachmentCategory,
  isAttachmentCreate,
  isAttachmentFolder,
  isAttachmentId,
  isAttachmentNaming,
  isAttachmentUpdate,
  isAttachmentVariantId,
  isContentType,
  isResolveMethod,
  isResolveResponse
});
//# sourceMappingURL=types.generated.js.map
